// extracted by mini-css-extract-plugin
export default {"supplierSection":"wk0cY9QXpPRpwaLJw8Jb__supplierSection___","suppliersTable":"CBu6cybOGVXfGDAHF5IR__suppliersTable___","contentRow":"gGWLqKnnEde3kmxoDQp6__contentRow___"};